import styled from 'styled-components'
import { Box } from '@nominex/dex-uikit'

type DividerProps = {
  dashed?: boolean
  bold?: boolean
  semibold?: boolean
  color?: string
  vertical?: boolean
}

const getWidth = (bold, semibold) => (bold ? 3 : semibold ? 2 : 1)

export const Divider = styled(Box)<DividerProps>`
  ${({ vertical, bold, semibold }) =>
    vertical
      ? `border-left-width: ${getWidth(bold, semibold)}px;
         min-height: 100%;`
      : `border-top-width: ${getWidth(bold, semibold)}px;
         width: 100%;`}
  border-style: ${({ dashed }) => (dashed ? 'dashed' : 'solid')};
  border-color: ${({ theme, color = `${theme.colors.white}19` }) => color};
`

export default Divider
